<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListTipos";

export default {
  data() {
    return {
      subjectPermission: "Tipos"
    };
  },
  methods: {},
  components: {
    List
  }
};
</script>
